var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container",
      staticStyle: { "padding-bottom": "50px", background: "#f4f5f7" },
    },
    [
      _c(
        "BjSteps",
        {
          attrs: {
            active: "3",
            title: _vm.$t("billingPage.DEPDeposit"),
            defaultOptions: [
              _vm.$t("billingPage.DEPsub"),
              _vm.$t("billingPage.DEPAppro"),
              _vm.$t("billingPage.DEPTop"),
            ],
          },
        },
        [
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("backText"))),
              ]),
              _vm.$route.query.type == "add"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirm },
                    },
                    [_vm._v(_vm._s(_vm.$t("submitText")))]
                  )
                : _vm._e(),
              _vm.$route.query.type == "view" && !_vm.$store.getters.cusId
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.form.status != "Pending",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleFormOpen("Received")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("ReceivedText1")))]
                  )
                : _vm._e(),
              _vm.$route.query.type == "view" && !_vm.$store.getters.cusId
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.form.status != "Pending",
                        type: "primary",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleFormOpen("Declined")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("DeclinedText1")))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            "label-position": "top",
            rules: _vm.rules,
            "label-width": "160px",
          },
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-spacebetween profit-top" },
            [
              _c("BjDivider", [_vm._v(_vm._s(_vm.$t("billingPage.DEPInfo")))]),
              _c(
                "div",
                { staticClass: "profit-topLeft" },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: { "margin-top": "10px" },
                      attrs: { gutter: 20 },
                    },
                    [
                      !_vm.$store.getters.cusId
                        ? _c(
                            "el-col",
                            { attrs: { span: _vm.colSpan } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("billingPage.DEPFrom"),
                                    prop: "clientCode",
                                  },
                                },
                                [
                                  _c("BjSelectLov", {
                                    attrs: {
                                      disabled: _vm.$route.query.type == "view",
                                      "option-list": _vm.clientCodeList,
                                      placeholder: _vm.$t(
                                        "billingPage.DEPFrom"
                                      ),
                                    },
                                    model: {
                                      value: _vm.form.clientCode,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "clientCode", $$v)
                                      },
                                      expression: "form.clientCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$store.getters.cusId
                        ? _c(
                            "el-col",
                            { attrs: { span: _vm.colSpan } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("billingPage.DEPFrom"),
                                    prop: "clientCode",
                                  },
                                },
                                [
                                  _c("BjInput", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.form.clientCode,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "clientCode", $$v)
                                      },
                                      expression: "form.clientCode",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$store.getters.cusId
                        ? _c(
                            "el-col",
                            { attrs: { span: _vm.colSpan } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("billingPage.DEPDetail"),
                                    prop: "addressFrom",
                                  },
                                },
                                [
                                  _c("BjInput", {
                                    attrs: {
                                      disabled: _vm.$route.query.type == "view",
                                    },
                                    on: { input: _vm.inputFrom },
                                    model: {
                                      value: _vm.addressFrom,
                                      callback: function ($$v) {
                                        _vm.addressFrom = $$v
                                      },
                                      expression: "addressFrom",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan * 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.DEPTo"),
                                prop: "addressTo",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  disabled: "",
                                  placeholder:
                                    "Cargo Solutions Group Pty Ltd, 063121, 11418410",
                                },
                                model: {
                                  value: _vm.addressTo,
                                  callback: function ($$v) {
                                    _vm.addressTo = $$v
                                  },
                                  expression: "addressTo",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.DEPAmount"),
                                prop: "amount",
                              },
                            },
                            [
                              _c(
                                "BjInputMoney",
                                {
                                  attrs: {
                                    disabled: _vm.$route.query.type == "view",
                                    placeholder: _vm.$t(
                                      "billingPage.DEPAmount"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.form.amount,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "amount", $$v)
                                    },
                                    expression: "form.amount",
                                  },
                                },
                                [
                                  _c("template", { slot: "append" }, [
                                    _vm._v("AUD"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.DEPTime"),
                                prop: "transferTime",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                staticClass: "full-width",
                                attrs: {
                                  format: "dd/MM/yyyy mm:ss",
                                  "value-format": "yyyy-MM-dd HH:mm:ss",
                                  type: "datetime",
                                  placeholder: _vm.$t("chooseText"),
                                  disabled: _vm.$route.query.type == "view",
                                },
                                model: {
                                  value: _vm.form.transferTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "transferTime", $$v)
                                  },
                                  expression: "form.transferTime",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.colSpan * 2 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("billingPage.DEPDes"),
                                prop: "description",
                              },
                            },
                            [
                              _c("BjInput", {
                                attrs: {
                                  disabled: _vm.$route.query.type == "view",
                                  maxlength: _vm.MAX_LENGTH.PRIORITY,
                                  type: "textarea",
                                  rows: 5,
                                  "show-word-limit": "",
                                  autosize: "",
                                },
                                model: {
                                  value: _vm.form.description,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "description", $$v)
                                  },
                                  expression: "form.description",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: _vm.colSpan * 2 } }, [
                        _c(
                          "div",
                          {
                            staticClass: "flex flex-spacebetween",
                            staticStyle: { "margin-top": "10px" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "profit-fileLeft" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t("billingPage.DEPScre"),
                                      prop: "fileList",
                                    },
                                  },
                                  [
                                    _c(
                                      "UploadFile",
                                      {
                                        ref: "UploadFileRef",
                                        staticClass: "avatar-uploader",
                                        attrs: {
                                          limit: 1,
                                          "limit-size": 5 * 1024,
                                          accept: "image/png,image/jpeg,",
                                          "accept-list": [
                                            "image/jpeg",
                                            "image/png",
                                          ],
                                          "auto-upload": "",
                                          "limit-hide": "",
                                        },
                                        on: {
                                          handleFileListChange: _vm.fileChange,
                                        },
                                      },
                                      [
                                        _c(
                                          "template",
                                          { slot: "default" },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  disabled:
                                                    _vm.form.screenshotUrl ||
                                                    _vm.$route.query.type ==
                                                      "view",
                                                  size: "small",
                                                  type: "primary",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "BusinessImportHistory.page.SelectFile"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "profit-fileRight" },
                              [
                                _vm.form.screenshotUrl
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "file",
                                          staticStyle: {
                                            "line-height": "1.5",
                                            "font-weight": "500",
                                            "font-size": "14px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fileUpload" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "flex-align flex-spacebetween",
                                                  staticStyle: {
                                                    color: "#3173d0",
                                                    cursor: "pointer",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "flex" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "ellipsis",
                                                          staticStyle: {
                                                            width: "120px",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mr20",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "screenshot.png"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex-align flex-spacebetween",
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "edit-btn",
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                            "margin-right":
                                                              "10px",
                                                          },
                                                          attrs: {
                                                            size: "mini",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.downloadImageUrl(
                                                                _vm.form
                                                                  .screenshotUrl,
                                                                "screenshot.png"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "downloadText"
                                                              )
                                                            )
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-download el-icon--right",
                                                          }),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          staticClass:
                                                            "delete-btn",
                                                          staticStyle: {
                                                            "font-size": "12px",
                                                            "margin-right":
                                                              "10px",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              _vm.$route.query
                                                                .type == "view",
                                                            size: "mini",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.delImg()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("delText")
                                                            )
                                                          ),
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-delete red el-icon--right",
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "profit-topRight" },
                [
                  _c("BjDivider", [
                    _vm._v(
                      _vm._s(_vm.$t("billingPage.DEPID")) +
                        ": " +
                        _vm._s(_vm.form.paymentId)
                    ),
                  ]),
                  _vm.form.screenshotUrl
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            height: "370px",
                            border: "1px",
                          },
                        },
                        [
                          _c("img", {
                            staticStyle: {
                              width: "100%",
                              height: "100%",
                              "object-fit": "contain",
                            },
                            attrs: { src: _vm.form.screenshotUrl },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.form2.title,
            visible: _vm.addDialogVisible,
            width: "500px",
            "before-close": _vm.handleFormClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form2",
              attrs: {
                model: _vm.form2,
                rules: _vm.rules2,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.DEPRemark"),
                    prop: "remark",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      maxlength: _vm.MAX_LENGTH.PRIORITY,
                      type: "textarea",
                      rows: 5,
                      "show-word-limit": "",
                      autosize: "",
                    },
                    model: {
                      value: _vm.form2.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form2, "remark", $$v)
                      },
                      expression: "form2.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.handleFormClose("form2")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("form2")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }